import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "flash" ]

  connect() {
    setTimeout(() => {
      this.flashTargets.forEach( message => message.remove())
    }, 7000)
  }

  close(event) {
    event.currentTarget.remove()
  }
}
